import React from "react";
import styled from "@emotion/styled";
import { Link } from "@reach/router";

import { useTheme } from "../../contexts/themeContext";

function Header() {
  const theme = useTheme();

  return (
    <StyledHeader color={theme.mainDark} theme={theme}>
      <Link to="/">Dameca LV</Link>
      <p>Livrări en-gros</p>
    </StyledHeader>
  );
}

const StyledHeader = styled.header`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  color: ${props => props.color};
  margin-left: 40px;
  margin-top: 40px;

  a {
    font-size: 35px;
    font-weight: bold;
    margin-bottom: 8px;
    text-decoration: none;
    outline: none;
  }

  a {
    color: ${props => props.theme.secondDark};
  } /* Unvisited link  */
  a:visited {
    color: ${props => props.theme.secondDark};
  } /* Visited link    */
  a:hover {
    color: #${props => props.theme.secondDark};
  } /* Mouse over link */
  a:active {
    color: ${props => props.theme.secondDark};
  } /* Selected link   */

  p {
    font-size: 14px;
  }
`;

export default Header;
